module.exports = __webpack_public_path__ + "static/media/r5.5b61571f.jpg";